"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processModemProgress = exports.HighResultFactor = exports.modemMeasurement = void 0;
const rxjs_1 = require("rxjs");
const openapi_1 = require("../../../generated/openapi");
const R = __importStar(require("ramda"));
const NQValue_1 = require("../NQValue");
const utils_1 = require("../util/utils");
/**
 * The whole modem logic depends on the following inputs:
 * 1. modemAPI - data.udp?.status: UdpResultModelStatusEnum
 * 2. modemAPI - data.udp?.value: number | null
 * 3. modemAPI - data.evaluation.downloadClient: boolean | null, data.evaluation.uploadClient: boolean | null
 * 4. initAPI  - data.data.modem.bookedDownloadSpeedMax: number | null , data.data.modem.bookedUploadSpeedMax: number | null
 * 5. initAPI  - data.cmts.isModemTestAvailable: boolean
 */
function modemMeasurement(prepareResult, speedtestApi) {
    var _a, _b, _c, _d, _e;
    const isCustomer = !R.isNil((_a = prepareResult.init.modem) === null || _a === void 0 ? void 0 : _a.bookedDownloadSpeedMax) && !R.isNil((_b = prepareResult.init.modem) === null || _b === void 0 ? void 0 : _b.bookedUploadSpeedMax);
    const isModemTestAvailable = (_d = (_c = prepareResult.init.cmts) === null || _c === void 0 ? void 0 : _c.isModemTestAvailable) !== null && _d !== void 0 ? _d : true;
    if (!isCustomer) {
        return (0, rxjs_1.from)([(0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotACustomer, null, null, null, null, null, null)]);
    }
    const fetchModemProgress = () => (0, rxjs_1.lastValueFrom)(speedtestApi.modem(prepareResult.init.speedtest.id));
    return (0, rxjs_1.from)(processModemProgress(fetchModemProgress, isModemTestAvailable, (_e = prepareResult.init.modem) === null || _e === void 0 ? void 0 : _e.bookedDownloadSpeedMax));
}
exports.modemMeasurement = modemMeasurement;
exports.HighResultFactor = 1.5;
function processModemProgress(fetchModemProgress, isModemTestAvailable, bookedDownloadSpeedMax, maxNumberOfPolls = 10 * 60, delayBetweenPolls = 1 /*sec*/) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return __asyncGenerator(this, arguments, function* processModemProgress_1() {
        for (const _ of R.range(0, maxNumberOfPolls)) {
            const curr = yield __await(fetchModemProgress());
            const status = (_a = curr.data) === null || _a === void 0 ? void 0 : _a.udp.status;
            const value = (_b = curr.data) === null || _b === void 0 ? void 0 : _b.udp.value;
            const isSatisfactory = (_d = (_c = curr.data) === null || _c === void 0 ? void 0 : _c.evaluation.downloadClient) !== null && _d !== void 0 ? _d : true;
            const snmpAvailable = (_f = (_e = curr.data) === null || _e === void 0 ? void 0 : _e.snmp.available) !== null && _f !== void 0 ? _f : null;
            const parallelTraffic = snmpAvailable === true ? (0, utils_1.nullOrValue)((_g = curr.data) === null || _g === void 0 ? void 0 : _g.snmp.parallelTraffic) : null;
            const connectionType = (0, utils_1.nullOrValue)((_h = curr.data) === null || _h === void 0 ? void 0 : _h.snmp.connectionType);
            const speedtestState = {
                downloadClient: ((_j = curr.data) === null || _j === void 0 ? void 0 : _j.evaluation.downloadClient) !== false,
                uploadClient: ((_k = curr.data) === null || _k === void 0 ? void 0 : _k.evaluation.uploadClient) !== false,
                downloadUdp: (0, utils_1.nullOrValue)((_l = curr.data) === null || _l === void 0 ? void 0 : _l.evaluation.downloadUdp),
            };
            const wifiExtenderMode = (0, utils_1.nullOrValue)((_m = curr.data) === null || _m === void 0 ? void 0 : _m.evaluation.wifiExtenderMode);
            const wifiExtenderRegStatus = (0, utils_1.nullOrValue)((_o = curr === null || curr === void 0 ? void 0 : curr.data) === null || _o === void 0 ? void 0 : _o.evaluation.wifiExtenderRegStatus);
            switch (status) {
                /* Transient cases */
                case openapi_1.UdpResultModelStatusEnum.Pending:
                    yield yield __await((0, NQValue_1.createModemIntermediateResolving)());
                    break;
                case openapi_1.UdpResultModelStatusEnum.PendingUdp:
                    yield yield __await((0, NQValue_1.createModemIntermediateExecuting)());
                    break;
                /* Terminal cases */
                case openapi_1.UdpResultModelStatusEnum.Done:
                    if (value) {
                        if (bookedDownloadSpeedMax * exports.HighResultFactor <= value) {
                            yield yield __await((0, NQValue_1.createModemFinalFailed)("Result is too high", speedtestState, parallelTraffic, connectionType, snmpAvailable, wifiExtenderMode, wifiExtenderRegStatus));
                        }
                        else {
                            yield yield __await((0, NQValue_1.createModemFinalAvailable)(value, speedtestState, parallelTraffic, connectionType, snmpAvailable, wifiExtenderMode, wifiExtenderRegStatus));
                        }
                        return yield __await(void 0);
                    }
                    else {
                        if (isSatisfactory) {
                            yield yield __await((0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotNeeded, speedtestState, parallelTraffic, connectionType, snmpAvailable, wifiExtenderMode, wifiExtenderRegStatus));
                            return yield __await(void 0);
                        }
                        else {
                            if (isModemTestAvailable) {
                                yield yield __await((0, NQValue_1.createModemFinalFailed)(`No value with status 'done', server response body: ${(0, utils_1.safeStringify)(curr)}`, speedtestState, parallelTraffic, connectionType, snmpAvailable, wifiExtenderMode, wifiExtenderRegStatus));
                                return yield __await(void 0);
                            }
                            else {
                                yield yield __await((0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotAvailable, speedtestState, parallelTraffic, connectionType, snmpAvailable, wifiExtenderMode, wifiExtenderRegStatus));
                                return yield __await(void 0);
                            }
                        }
                    }
                case openapi_1.UdpResultModelStatusEnum.Error:
                    yield yield __await((0, NQValue_1.createModemFinalFailed)(`Modem status error, server response body: ${(0, utils_1.safeStringify)(curr)}`, speedtestState, parallelTraffic, connectionType, snmpAvailable, wifiExtenderMode, wifiExtenderRegStatus));
                    return yield __await(void 0);
                case undefined:
                    yield yield __await((0, NQValue_1.createModemFinalFailed)(`Modem status is undefined, server response body: ${(0, utils_1.safeStringify)(curr)}`, speedtestState, parallelTraffic, connectionType, snmpAvailable, wifiExtenderMode, wifiExtenderRegStatus));
                    return yield __await(void 0);
            }
            yield __await(delay(delayBetweenPolls));
        }
        yield yield __await((0, NQValue_1.createModemFinalFailed)("Timeout polling the modem api", null, null, null, null, null, null));
    });
}
exports.processModemProgress = processModemProgress;
function delay(intervalSec) {
    return new Promise(resolve => setTimeout(resolve, intervalSec * 1e3));
}
//# sourceMappingURL=ModemController.js.map